var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 19c1.17-4 4.5-6 10-6s8.83 2 10 6"
  }))));
};
export default SvgUser;